import { DelayManager } from "./DelayManager";

class Delay {
    callbacks: any = {};

    set = (id: string, callback: Function, time: number) => {
        if(this.callbacks[id]) this.callbacks[id].destroy();
        this.callbacks[id] = new DelayManager(callback, time);
    }

}


// export Delay class instance (singleton)
export const __delay = new Delay();

